import React, { useState, useRef, useEffect } from 'react';
import { IoIosNotifications } from 'react-icons/io';
import { GiHamburgerMenu } from 'react-icons/gi';
import { RiArrowDropDownLine } from "react-icons/ri";
import DropdownUser from './DropdownAdmin';
import { useDispatch, useSelector } from 'react-redux';
import { setLanguage } from '../redux/LanguageSlice'; 
function Header({ toggleSidebar, setUser }) {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef();
  const dispatch = useDispatch();
  const { lang } = useSelector((state) => state.language);
  const { translations } = useSelector((state) => state.language);
  const handleLanguageChange = (newLang) => {
    dispatch(setLanguage(newLang));
    setDropdownOpen(false); // close after selection
  };

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);
  return (
    <header className="sticky top-0 bg-[#5A189A] text-white z-70 w-full h-16 flex items-center px-4 ">
      <div className="flex justify-between w-full items-center">
        <div className="flex items-center gap-3">
          <GiHamburgerMenu className="text-2xl cursor-pointer" onClick={toggleSidebar} />
          <h1 className="text-lg font-semibold">{translations.header.dashboard}</h1>
        </div>

        <div className="flex items-center gap-4 relative">
          {/* <IoIosNotifications className="text-2xl cursor-pointer" /> */}

          {/* Language Dropdown using Redux */}
          <div className="relative " ref={dropdownRef}>
            <span
              onClick={() => setDropdownOpen((prev) => !prev)}
              className="cursor-pointer select-none flex items-center"
            >
              <RiArrowDropDownLine className='text-2xl' /> {lang.toUpperCase()}
            </span>

            {dropdownOpen && (
              <ul className="absolute bg-gray-800 text-white mt-2 rounded shadow z-80 right-0 w-24 text-md p-0">
                <li
                  className="hover:bg-gray-700 px-3 py-2 my-2 cursor-pointer"
                  onClick={() => handleLanguageChange("ar")}
                >
                  العربية
                </li>
                <li
                  className="hover:bg-gray-700 px-3 py-2 my-2 cursor-pointer"
                  onClick={() => handleLanguageChange("en")}
                >
                  English
                </li>
              </ul>
            )}
          </div>

          <DropdownUser setUser={setUser} />
        </div>
      </div>
    </header>
  );
}

export default Header;
